import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  Observable,
  catchError,
  map,
  of,
  take,
  tap
} from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class EntregablesService {

  constructor(
    private http: HttpClient
  ) { }

  descargarEntregable(paylod: {
    entrada: string;
    entregable: string;
  }): Observable<any> {
    return this.http
      .post<any>(`${environment.entregables.descarga}`, {
        ...paylod,
      })
      .pipe(
        tap((data) => console.log("API descargarEntregable", data)),
        take(1),
        map((data: any) => {
          return { error: false, data };
        }),
        catchError((error) => {
          console.error("Error fetching descargarEntregable", error);
          return of({ error: true });
        })
      );
  }
}
